// extracted by mini-css-extract-plugin
module.exports = {"grey100":"#F2F2F7","green300":"#235545","container":"PackageCardContent_container__LOhdu","rounded":"PackageCardContent_rounded__isXJ7"};